import {
  TicketChannel,
  TicketPerson,
  TicketScope,
  TicketStatus,
} from '../types/ticket'

export const ticketPeople: TicketPerson[] = [
  'Alessio',
  'Lorenzo',
  'Gian Franco',
  'Tiziano',
]

export const ticketScopes: TicketScope[] = ['Azienda', 'Interno']

export const ticketChannels: TicketChannel[] = ['Standard', 'Urgente']

export const ticketStatuses: TicketStatus[] = ['Aperto', 'Sospeso', 'Chiuso']
